import {ISelectValues} from "../../../../../component/ISelectValues";

export const ID_FILTER_OWNER = "owner";
export const ID_FILTER_CUSTOMER_ID = "customerId";
export const ID_FILTER_CARD_TYPE = "cardType";
export const ID_FILTER_STATUS = "status";
export const ID_FILTER_CREATION_DATE_FROM = "creationDateFrom";
export const ID_FILTER_CREATION_DATE_TO = "creationDateTo";
export const ID_FILTER_DUE_DATE_FROM = "dueDateFrom";
export const ID_FILTER_DUE_DATE_TO = "dueDateTo";
export const ID_FILTER_CARD_NETWORK = "cardNetwork";
export const ID_FILTER_COUNTRY = "country";
export const ID_FILTER_ISSUER = "issuer";
export const ID_FILTER_CATEGORY = "category";
export const ID_FILTER_CORRELATION_NAME = "correlationName";
export const ID_FILTER_CORRELATION_ID = "correlationId";
export const ID_FILTER_PAN = "pan";
export const ID_FILTER_LEGAL_ENTITIES = "legal-entities";
export const ID_FILTER_DEALERS = "dealers";

export const cardTypes: ISelectValues[] = [
  {
    value: "CREDITCARD",
    label: "tools.types.CREDITCARD",
  },
  {
    value: "DEBITCARD",
    label: "tools.types.DEBITCARD",
  },
  {
    value: "PREPAIDCARD",
    label: "tools.types.PREPAIDCARD",
  },
];

export const brands: ISelectValues[] = [
  {
    value: "VISA",
    label: "tools.brands.VISA",
  },
  {
    value: "AMERICAN",
    label: "tools.brands.AMERICAN",
  },
  {
    value: "MASTERCARD",
    label: "tools.brands.MASTERCARD",
  }
];
export const categories: ISelectValues[] = [
  {
    value: "STANDARD",
    label: "tools.categories.STANDARD",
  },
  {
    value: "CLASSIC",
    label: "tools.categories.CLASSIC",
  },
  {
    value: "BUSINESS",
    label: "tools.categories.BUSINESS",
  },
  {
    value: "PREPAID",
    label: "tools.categories.PREPAID",
  },
  {
    value: "VPAY",
    label: "tools.categories.VPAY",
  }
];

export const correlationName: ISelectValues[] = [
  {
    value: "DBE",
    label: "tools.productType.TRANSVERSAL",
  },
  {
    value: "SUBSCRIPTION",
    label: "tools.productType.SUBSCRIPTION",
  },
  {
    value: "MOBILITY VOUCHER",
    label: "tools.productType.MOBILITY_VOUCHER",
  },
  {
    value: "AMAZON VOUCHER",
    label: "tools.productType.AMAZON_VOUCHER",
  },
  {
    value: "PRE_PAID",
    label: "tools.productType.PRE_PAID",
  },
  {
    value: "RA",
    label: "tools.productType.RA",
  }
];

const BLUE = "secondary.transparent";
const PINK = "accent.transparent";
const YELLOW = "warning.transparent";
const GREY = "neutral.light";
const GREEN = "success.transparent";
const RED = "error.transparent";

export const statuses: ISelectValues[] = [
  {
    value: "ACTIVE",
    label: "tools.statuses.ACTIVE",
    color: GREEN,
  },
  {
    value: "DELETED",
    label: "tools.statuses.DELETED",
    color: RED,
  },
  {
    value: "EXPIRED",
    label: "tools.statuses.EXPIRED",
    color: YELLOW,
  }
];

export const getSummaryFields = () => {
  return [
    "UNREGISTRED",
    "ACTIVE",
    "UNDEFINED",
    "EXPIRED",
    "PENDING",
    "ABORTED",
    "DELETED"
  ];
}

export const customDefaultValues = {
  owner: "",
  customerId: "",
  cardType: "",
  creationDateFrom: null,
  creationDateTo: null,
  dueDateFrom: null,
  dueDateTo: null,
  cardNetwork: "",
  country: [],
  issuer: "",
  category: "",
  correlationName: "",
  correlationId: "",
  pan: "",
  dealers: []
};

export const checkCorrelationName = (params : any, t: any) =>{
  let productType = "---";
  let raCode = params.data.rentalId;
  if (raCode){
    productType = "RA";
  }
  let cName = params.value;
  if (cName && cName.includes(":")){
    cName = cName.substring(0, cName.indexOf(":"));
  }
  if (cName && cName.includes("DBE")){
    cName = "DBE";
  }

  let typology = convertTypology(correlationName,cName);
  typology = typology ? t(typology) : "---";
  return params.value ?  typology :  productType;
}

export const checkCorrelationNameExcel = (params : any, t: any) =>{
  let productType = "---";
  let raCode = params.data.rentalId;
  if (raCode){
    productType = "RA";
  }
  let cName = params.data.correlationName;
  if (cName && cName.includes(":")){
    cName = cName.substring(0, cName.indexOf(":"));
  }
  if (cName && cName.includes("DBE")){
    cName = "DBE";
  }
  let typology = convertTypology(correlationName,cName);
  typology = typology ? t(typology) : "---";
  return params.data.correlationName ?  typology :  productType;
}

export const checkCorrelationID = (params : any, t: any) =>{
  let productId = "---";
  let raCode = params.data.rentalId;
  let correlationId = params.data.correlationId;
  if (!correlationId && raCode){
    productId = raCode;
  }
  return params.data.correlationId ? params.data.correlationId :  productId;
}

export const convertTypology = (type: ISelectValues[], value: string) => {
  const item = type.find((item) => item.value === value);
  return item ? item.label.replace("tools.", "") : "";
}
